// extracted by mini-css-extract-plugin
export default {"tabContent":"MaterialDetail_tabContent__Aw9uw","tabItem":"MaterialDetail_tabItem__C86oL"};